import { Component, Input } from '@angular/core';
import { AuthorizationService } from '../../services/authorization.service';
import { GlobalFilterService } from '../../services/global-filter.service';
import { UserDetailsService } from '../../services/user-details.service';
@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.css'],
})

export class UserDetailsComponent {
  @Input() username: string
  @Input() applicationReference: number

  private readonly USER_DETAILS_FEATURE = 'Get-List::ServiceEventTransactionHistory'
  private readonly RECON_USER = 'RECONUSER'

  public userDetailsLoading: boolean

  public get showDetailsLink(): boolean {
    return this.authorizationService.hasFeature(this.USER_DETAILS_FEATURE, false)
  }

  public get isReconUserAndHasAppRefNumber(): boolean {
    return this.username.trim() === this.RECON_USER && this.applicationReference > 0;
  }

  constructor(private authorizationService: AuthorizationService,
              private globalFilterService: GlobalFilterService,
              private userDetailsService: UserDetailsService) {
  }

  public async getUserDetails(): Promise<void> {
    this.userDetailsLoading = true;

    let userDetails = await this.userDetailsService.getUserDetails(this.globalFilterService.selectedEnvironment.ClientId4Digit, this.applicationReference)

    this.username = userDetails.UserDetails_UserName
    this.userDetailsLoading = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/user-details/user-details.component.ts